export default [{
    title: 'Mon contact Bubble-In',
    icon: 'UsersIcon',
    route: 'mon-contact',
    // tag: 3,
    // tagVariant: 'light-info',
    typeUser: 'courtier',
  }]
  